import { render, staticRenderFns } from "./ModalConstructor.vue?vue&type=template&id=37a106e5&"
import script from "./ModalConstructor.vue?vue&type=script&lang=js&"
export * from "./ModalConstructor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/user/projects/zp-front-up/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37a106e5')) {
      api.createRecord('37a106e5', component.options)
    } else {
      api.reload('37a106e5', component.options)
    }
    module.hot.accept("./ModalConstructor.vue?vue&type=template&id=37a106e5&", function () {
      api.rerender('37a106e5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/ModalConstructor.vue"
export default component.exports